import PropTypes from "prop-types";
import { useAuthUser } from "_hooks";
import { AppLoader } from "_lib";
import { useNavigate } from "react-router-dom";
import { injectNavigate } from "_helpers";

const AuthRoutes = (props) => {
  const { children } = props;

  injectNavigate(useNavigate());

  const { isLoading } = useAuthUser();

  return isLoading ? <AppLoader /> : <>{children}</>;
};

AuthRoutes.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthRoutes;
